import { createContext, useContext } from 'react';

// The activation tick for the page a hook lives in (keep-alive-page-host
// AC3/AC4). The page host provides, per mounted slot, the current tick for that
// slot's key. The value bumps on every *return* to a kept page (see
// pages/activation.ts) and is 0 on first mount. A data hook reads it and fires a
// silent background re-fetch whenever it changes — without dropping to a loading
// state, so the last-known content holds the spot.
//
// Default 0 means: outside a page host (e.g. unit tests rendering a page in
// isolation, or the bare App loading state) the tick never changes, so hooks
// behave exactly as before this story — fetch once on mount, no revalidation.
const ActivationTickContext = createContext<number>(0);

export const ActivationTickProvider = ActivationTickContext.Provider;

// Read the current activation tick for the surrounding page. Data hooks call
// this and revalidate-on-change. Returns 0 when there is no host (back-compat).
export function useActivationTick(): number {
  return useContext(ActivationTickContext);
}
